import { AddCartItemType } from '@lentau/cart/shared/interfaces';
import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { checkEmptyFields } from '../utils';
import { CartDataProps, CartLookupBodyDto } from '@lentau/cart/shared/interfaces';

export function cartLookupHandler(body: CartDataProps): EventProperties {
  {
    if (!body.CartList) {
      return [];
    }

    const order = body.CartList[0];

    const fieldsToCheck = [
      {
        fieldToCheck: order.TotalWeight,
        errorName: 'totalWeightIsEmpty',
      },
      {
        fieldToCheck: order.UserId,
        errorName: 'userIdIsEmpty',
      },
      {
        fieldToCheck: order.BaseTotalCost,
        errorName: 'baseTotalCostIsEmpty',
      },
    ];

    return checkEmptyFields(fieldsToCheck); //   there may be a custom validation like in cart-item-clear-handler.ts
  }
}

export function cartFromOrderAddHandler(data: CartLookupBodyDto): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.CartList[0]?.Id,
        errorName: 'IdIsEmpty',
      },
      {
        fieldToCheck: data?.CartList[0]?.CartCost,
        errorName: 'CartCostIsEmpty',
      },
      {
        fieldToCheck: data?.CartList[0]?.BaseTotalCost,
        errorName: 'BaseTotalCostIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function cartItemAddHandler(data: AddCartItemType): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data.Quantity,
        errorName: 'QuantityIsEmpty',
      },
      {
        fieldToCheck: data.GoodsItemId,
        errorName: 'GoodsItemIdIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
